import {toast} from '@/components/ui/toast'
type NotificationInput = string | {message?: string; description?: string; duration?: number}
function data(input: NotificationInput): {title?: string; description?: string; duration?: number} {
  if (typeof input === 'string') return {description: input}
  return {title: input.message, description: input.description, duration: input.duration}
}

export const notifications = {
  success(message: NotificationInput): void {
    toast(data(message))
  },
  error(message: NotificationInput): void {
    toast({...data(message), variant: 'destructive'})
  },
  warning(message: NotificationInput): void {
    toast(data(message))
  },
  info(message: NotificationInput): void {
    toast(data(message))
  },
  notify(title: string, description?: string): void {
    toast({title, description})
  },
}
